import { useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { I18n, Translate } from 'react-redux-i18n'
import { useNavigate } from 'react-router'
import { Element } from '../../../../common/html/element'
import { selectCompanyInfo } from '../../../../companyAnalysis/common/header/companyInfo/store/slice'
import EventEmitter, {
  SHOW_POPUP_ERROR,
  SHOW_POPUP_UPGRADE,
} from '../../../../helpers/EventEmitter'
import { selectUserType } from '../../../../layout/store/slice'
import { COMPONENTS } from '../../../../routers/constants'
import { USER_TYPE } from '../../../../utils/authorization'
import { COMPANY_TYPES } from '../../../../utils/common'
import { MAIN_SCREEN, SCREEN, TYPE_DOWNLOAD } from '../../constant'
import { DEFAULT_INDUSTRY } from '../../helper/companyAnalysis/industryAnalysis'
import Button from './Button'
import PopupSettingReport from './PopupSettingReport'
import classes from './index.module.scss'
import {
  changeActivePanel,
  selectCount,
  selectCurrentPortfolio,
  selectPanelById,
  selectPanelId,
} from './store/slice'

const ButtonSubmit = ({ saveTemplate, goToTemplateTable }) => {
  const dispatch = useDispatch()

  const navigate = useNavigate()

  const locale = useSelector((state) => state.i18n.locale)

  const companyInfo = useSelector(selectCompanyInfo)
  const currentPortfolio = useSelector(selectCurrentPortfolio)
  const countC = useSelector(selectCount(MAIN_SCREEN.COMPANY_ANALYSIS)) || 0
  const countP = useSelector(selectCount(MAIN_SCREEN.PORTFOLIO_INSIGHT)) || 0
  const panelId = useSelector(selectPanelId)
  const panelById = useSelector(selectPanelById)
  const userType = useSelector(selectUserType)

  const localeSystem = useRef()

  const [localePdf, setLocalePdf] = useState()
  const [isShowPopup, setIsShowPopup] = useState(false)
  const [typeDownload, setTypeDownload] = useState(TYPE_DOWNLOAD.PREVIEW)

  const isEnable = userType?.userTypeId === USER_TYPE.PREMIUM

  const exit = () => {
    navigate(COMPONENTS.dashboard.components.dashboard.route)
  }

  const openPopup = (typeDownload) => () => {
    if (!isEnable) {
      EventEmitter.dispatch(SHOW_POPUP_UPGRADE)
      return
    }
    const isPreview = typeDownload === TYPE_DOWNLOAD.PREVIEW
    if (
      (countC && !companyInfo.organizationId) ||
      (countP && !currentPortfolio)
    ) {
      EventEmitter.dispatch(SHOW_POPUP_ERROR, {
        title: isPreview
          ? 'dynamicReport.TITLE_WARNING_PREVIEW'
          : 'dynamicReport.TITLE_WARNING_EXPORT',
        messages: [
          isPreview
            ? I18n.t('dynamicReport.CONTENT_WARNING_PREVIEW')
            : I18n.t('dynamicReport.CONTENT_WARNING_EXPORT'),
        ],
      })
      return
    }

    if (companyInfo.companyType === COMPANY_TYPES.CORPORATE) {
      const panelError = panelId.find((id) => {
        const panel = panelById[id]
        if (
          panel.screen !==
          SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].INDUSTRY_ANALYSIS
        ) {
          return false
        }
        return !panel.setting?.[DEFAULT_INDUSTRY]
      })
      if (panelError) {
        EventEmitter.dispatch(SHOW_POPUP_ERROR, {
          title: 'common.WARNING',
          messages: [I18n.t('dynamicReport.WARNING_INDUSTRY_ANALYSIS')],
          callback: () => dispatch(changeActivePanel({ id: panelError })),
          button: 'dynamicReport.OK',
        })
        return
      }
    }

    setTypeDownload(typeDownload)
    setLocalePdf(locale)
    localeSystem.current = locale
    setIsShowPopup(true)
  }

  const countPanel = countC + countP

  return (
    <>
      <Element
        style={{ background: '#FFFFFF', border: '1px solid #D5D5D5' }}
        className={classes.btnSubmit}
        onClick={exit}
      >
        <Translate value="dynamicReport.EXIT" />
      </Element>
      <Button
        saveTemplate={saveTemplate}
        action={goToTemplateTable}
        isButtonSave
      >
        <Element
          style={{
            background: '#0553A5',
            color: '#FFFFFF',
            border: '1px solid #0553A5',
          }}
          className={classes.btnSubmit}
        >
          <Translate value="preferenceSetting.BTN_SAVE" />
        </Element>
      </Button>
      <Element
        style={{
          background: '#00A8B5',
          color: '#FFFFFF',
          border: '1px solid #00A8B5',
          opacity: countPanel ? 1 : 0.4,
        }}
        className={classes.btnSubmit}
        onClick={countPanel ? openPopup(TYPE_DOWNLOAD.PREVIEW) : undefined}
      >
        <Translate value="dynamicReport.PREVIEW" />
      </Element>
      <Element
        style={{
          background: '#2C73E8',
          color: '#FFFFFF',
          border: '1px solid #2C73E8',
          opacity: countPanel ? 1 : 0.4,
        }}
        className={classes.btnSubmit}
        onClick={countPanel ? openPopup(TYPE_DOWNLOAD.DOWNLOAD) : undefined}
      >
        <Translate value="dynamicReport.EXPORT_REPORT" />
      </Element>
      <PopupSettingReport
        localePdf={localePdf}
        isShowPopup={isShowPopup}
        typeDownload={typeDownload}
        localeSystem={localeSystem}
        setLocalePdf={setLocalePdf}
        setIsShowPopup={setIsShowPopup}
      />
    </>
  )
}

export default ButtonSubmit
